import { push } from 'redux-first-router';
import { getPath } from '@/router/utils';
import { ROUTE_COMPARE_COMPANY } from '@/constants/routes';
import { useIsMobileScreen } from '@/hooks/useMedia';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useTranslation } from '@/hooks/useTranslation';
import CompareIcon from '@simplywallst/ui-core/icons/TransferSolid';
import type { ActionClickProps, Action } from '../types';

export const useCompareAction = ({
  uniqueSymbol,
}: {
  uniqueSymbol: string | null;
}): Action => {
  const t = useTranslation();
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const handleClick = ({ trackEvent }: ActionClickProps) => {
    const comparePath = uniqueSymbol
      ? getPath({
          type: ROUTE_COMPARE_COMPANY,
          payload: { symbols: encodeURIComponent(uniqueSymbol) },
        })
      : '';
    if (!comparePath) return;
    trackEvent({ type: 'track', action: 'click', subject: 'compare' });
    push(comparePath);
  };

  return {
    key: 'compare',
    isDisabled: !uniqueSymbol,
    /**
     * Avoid showing the compare button on mobile web + native
     * This is because the current design of that page is not mobile-friendly
     * and currently just hides the content on mobile.
     */
    isHidden: RUNTIME_ENV === 'native' || isMobileScreen,
    smallProps: {
      label: t('page.companyReport.header.actions.compare'),
      icon: <CompareIcon />,
    },
    largeProps: {
      label: t('page.companyReport.header.actions.compare'),
    },
    handleClick,
  };
};
